import React from "react"
import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"
import Pill from "@irati/ui/src/Pill"
import FormattedMessage from "@irati/utils/lang"
import FormatMessage from "@irati/utils/lang/types/FormatMessage"

const UPLOAD_CSV = "wallet.adminReward.uploadCsv"
interface UploadCsvButtonTabProps {
  formatMessage: FormatMessage
}
const UploadCsvButtonTab = ({formatMessage}: UploadCsvButtonTabProps) => {
  return (
    <Flex gap={mainTheme.spacing.one} alignItems="center">
      <FormattedMessage id={UPLOAD_CSV} />
      <Pill text={formatMessage({id: "platform.new.label"})} backgroundColor={mainTheme.colors.perkbox.blue} isWhiteText />
    </Flex>
  )
}

export default UploadCsvButtonTab
